<template>
<div id="UserRoleHistory">
 <v-client-table :columns="columns" :data="tableData" :options="options">
    <div slot="beforeTable"> 
    <div class="row pl-3 pr-3">
      <!-- <div class="col-10 h-25 d-inline-block" style="background-color: rgba(0,0,255,.1)"> -->
       <div class="col-10 h-25 d-inline-block d-flex justify-content-center" style="background-color: #B9D9EB">
          <strong>{{Username}} : User Roles History</strong>
      </div>
      <div class="col-2 pl-2 h-25 d-inline-block d-flex justify-content-center" style="background-color:rgba(0,0,255,.1)">
          <strong>History Date</strong>
      </div>
    </div>
    </div>
 </v-client-table>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Modal from '@/Common/ModelPop.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant';
import Subtitle from '@/Common/Default/SubTitle.vue';  
export default {
       props:{ 
          UserData:'',
          Username:''     
     },
   data: function () {
    return {
            username: '',
            Action:'HIST',
            PopUpTitle :'Edit User Roles',
            Roles:[],
            AppServiceID:6,
            roleId:'',
            editUser:'',
            showExit:'',
            returnUrl:'',
            isModalVisible: false,
            showModal: false,
            PopUpVar:PopUpVariant,
            //columns: ['username', 'role','servicetype','clinicno','clinicname','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate','insertdate','insertby'],
            //columns: ['username', 'role','servicetype','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate','insertdate'],//,'insertby'],
            columns: ['role','servicetype','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate','insertdate'],
            tableData: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search User Data:",
              filterPlaceholder:"Filter Data",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          }, 
       
          responseAdapter({data}) {
           
              return {
                data: formatData,
                count: data.length
              };
             
            },
          perPage:5,
          perPageValues:[5,10,15,25],
          dateColumns:['expirydate','effectivedate'],
          toMomentFormat: 'YYYY-MM-DD',
         
          templates: {
            effectivedate(h, row){
              return moment(row.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            expirydate(h, row) {
              return moment(row.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
            },
            createddate(h, row) {          
              return moment(row.createddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            modifieddate(h, row) {          
              return moment(row.modifieddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            insertdate(h, row) {          
               return moment(row.insertdate,"YYYY-MM-DD h:mm:ss a").format('YYYY/MM/DD h:mm:ss a');  
            },
          },
          headings: {
            edit: '',
            //username: 'User ID',
            role: 'Role',
            status: 'Status',
            servicetype: 'Service Type',
            clinicno:    'Clinic Number',
            clinicname:   'Clinic Name',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',            
            createdby: 'Created By',
            createddate: 'Created Date',
            lastmodifiedby: 'Modified By',
            modifieddate: 'Modified Date',
            insertdate: 'History Date Time'
             
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['role','servicetype','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate','insertdate'],
          filterable: ['role','servicetype','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate','insertdate'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
        }
      }
    },
 
    created () {
      //console.log(this.UserData)
      //this.username = this.UserData.username;
       //this.tableData = this.UserData
      //this.loadTable();
    },
    mounted(){
        this.tableData = this.UserData;
    },
    methods: {  
    },
    components: {
    Modal:Modal,
    Card,
    CardBody,
    TileNote,Subtitle
    },
    computed:{ 
    },
     filters: {
      moment: function (date) {        
      return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
      },
 
    },
}
</script>

<style>

</style>